var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center"},[_c('transition',{attrs:{"name":_vm.transitionName,"mode":"out-in"}},[_c(_vm.currentStepComponent,{tag:"component",staticClass:"form-container",on:{"loading-toggle":_vm.handleLoadingToggle}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-109abb44","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/AdditionalInformationConstrucao.vue
// module id = ZQ+y
// module chunks = 0